// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TaskList } from '../../../common/types.tsx';
import type { State, ProjectState } from '../../model/types.tsx';
import { getAllTasks } from '../../tasks/index.tsx';

type NextGetTasksProps = {
	isDevOpsProject: boolean;
	shouldShowScrumOnboardingExperience: boolean;
	canCreateProject: boolean;
	routeName: string;
	projectState: ProjectState | null;
	taskGroupParent: string;
	mountedNudges: string[];
	isEligibleToUpdateSitename: boolean;
	isCustomerTemplateProject: boolean;
	isCrossProjectBoardToPlanUpsell: boolean;
	isWizardSimplifyQS: boolean;
	canEditPlans: boolean;
	premiumTrialOnSignup: boolean | undefined;
	taskList?: TaskList;
	isEligibleForTailoredOnboardingM2P5?: boolean;
	isEligibleForTailoredOnboardingM3?: boolean;
	isEligibleForTailoredOnboardingScrumAndSoftwareKanban?: boolean;
	teamType?: string;
	features?: {
		hasBacklog: boolean;
		hasSprint: boolean;
	};
};

export const nextGetTasks =
	(props: NextGetTasksProps): Action<State> =>
	({ getState, setState }) => {
		const { taskList } = getState();
		const tasks = getAllTasks({ ...props, taskList });
		setState({ tasks });
	};
